import React from 'react';
import './PanditLogo.css';

// The polygonal Chanakya-style portrait we're using as sutrumai.com's
// avatar. PNG, not true SVG — the source is a complex photo-realistic
// polygonal illustration; auto-tracing it to vector would be lossy.
// We DO ship two raster variants so small contexts (sidebar collapsed,
// favicon) don't pay the hero's bytes, and light/dark gets distinct
// treatment via CSS — different drop-shadows + brightness so the
// figure pops on both themes.
//
//   <PanditLogo />          → small (default), good for sidebars/avatars
//   <PanditLogo size="lg" /> → hero, for welcome screen + landing
//   <PanditLogo size="sm" /> → 128px source, for chips/messages
//
// All sizes are responsive — CSS caps width via the size class.

const SRC = {
  // Both files live in public/, served at the site root.
  //   - `sm` (sidebar chip, favicon-sized) stays as the mandala face
  //   - `lg` (welcome hero on Chat / Image) is the polygonal Chanakya
  //     PNG with a transparent background — keeps the rich colours that
  //     the auto-traced SVG washed out. Shipped at full source quality
  //     since the user wants the hero to look its best.
  sm: `${process.env.PUBLIC_URL || ''}/arthum-pandit-sm.png`,
  lg: `${process.env.PUBLIC_URL || ''}/chanakya-hero.png`,
};

function PanditLogo({
  size = 'sm',
  alt = 'sutrumai.com',
  className = '',
  style,
  ...rest
}) {
  // For tiny placements, the 128px asset is sharper at 1× and 2× than
  // browser-downscaled hero. Hero is reserved for >= 96px renderings.
  const src = size === 'lg' ? SRC.lg : SRC.sm;
  return (
    <img
      src={src}
      alt={alt}
      className={`pandit-logo pandit-logo-${size} ${className}`}
      style={style}
      draggable={false}
      {...rest}
    />
  );
}

export default PanditLogo;
